import React from "react";
import homeback from "./images/homeback.jpg"


const Projects = () =>{

    return(
        <div className="md:bg-cover bg-contain" style={{backgroundImage: `url(${homeback})`}}>
            
        </div>
    );
};

export default Projects;